
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    dataSet: {
      type: Object,
      default: () => ({ ralan: 0, igd: 0, ranap: 0 })
    }
  },
  computed: {
    chartData(): any {
      return {
        labels: ["Rawat Jalan", "IGD", "Rawat Inap"],
        datasets: [
          {
            data: [this.dataSet.ralan, this.dataSet.igd, this.dataSet.ranap],
            backgroundColor: ["#1E88E5", "#E53935", "#43A047"],
            borderWidth: 2
          }
        ]
      };
    },
    chartOptions(): any {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 72,
        legend: { display: false }
      };
    }
  },
  watch: {
    dataSet: {
      deep: true,
      handler() {
        (this as any).render();
      }
    }
  },
  mounted() {
    (this as any).render();
  },
  methods: {
    render() {
      (this as any).renderChart(this.chartData, this.chartOptions);
    }
  }
};
